import { Switch as AntSwitch } from "antd";
import { useState } from "react";

const Switch = ({ checked, onChange = () => {}, ...props }) => {
  const [loading, setLoading] = useState(false);

  return (
    <AntSwitch
      {...props}
      checked={checked}
      loading={loading}
      onChange={async (e) => {
        setLoading(true);
        try {
          await onChange(e);
        } catch (error) {
        } finally {
          setLoading(false);
        }
      }}
    />
  );
};

export default Switch;
